/**
 * VCB — il pannello di accessibilità si carica solo a chi lo usa.
 *
 * Pandectes carica `pandectes-a11y.js` su OGNI pagina: 301 KB grezzi, il
 * secondo file più pesante del sito dopo il CSS del tema e più del bundle
 * principale del tema stesso (256 KB). Su `/search` sono il 9% di tutto ciò
 * che il browser deve tenere in memoria — e i crash del renderer, 1 ogni 87
 * pagine e quasi tutti su Safari mobile, sono crash da memoria.
 *
 * L'app non offre un caricamento su richiesta: l'unica opzione è nascondere
 * l'icona, che però non evita il caricamento. Questo file lo evita.
 *
 * ## Chi lo riceve comunque
 *
 * ⚠️ Il pannello SALVA le preferenze in `localStorage` e le riapplica a ogni
 * caricamento. Chi ha scelto contrasto alto o testo ingrandito ha bisogno che
 * lo script parta sempre: differirlo per tutti sarebbe un peggioramento
 * proprio per le persone a cui serve.
 *
 * Quindi: se la chiave delle preferenze esiste, non si tocca niente e lo
 * script si carica come prima. Il rinvio vale solo per chi non ha mai aperto
 * il pannello — cioè quasi tutti.
 *
 * ## Come si aggancia
 *
 * Pandectes espone di suo un "grilletto personalizzato": qualunque elemento
 * con `id="triggerPandectesA11y"` o un link a `#triggerPandectesA11y` apre il
 * pannello. Sul sito c'è già, è la voce "Accessibilità" nel footer. Non
 * aggiungiamo nessun pulsante: usiamo la porta che hanno lasciato aperta.
 *
 * Al primo clic si carica lo script vero e si chiama `openDialog()` dalla loro
 * API pubblica (`window.PandectesAccessibility`), così il pannello si apre
 * senza chiedere un secondo clic.
 *
 * ## Cosa si risparmia davvero
 *
 * Si evita l'ANALISI e l'ESECUZIONE dei 301 KB, e la memoria che ne deriva.
 * Il download può essere già partito quando interveniamo: i byte di rete non
 * sono garantiti. È il costo di memoria quello che ci interessa, ed è quello
 * che si evita.
 *
 * ## Se Pandectes cambia le carte in tavola
 *
 * Dipendiamo da due nomi che non controlliamo: il file `pandectes-a11y.js` e
 * la chiave `pandectes-a11y-preferences`. Se cambiano, questo file smette
 * semplicemente di intercettare e lo script torna a caricarsi come oggi:
 * fallisce nel verso giusto. Manda comunque un evento a GA4 perché ce ne
 * accorgiamo invece di scoprirlo per caso.
 */
(function () {
  'use strict';

  var FILE = 'pandectes-a11y';
  var CHIAVE_PREF = 'pandectes-a11y-preferences';
  var SELETTORE = '#triggerPandectesA11y, a[href*="#triggerPandectesA11y" i]';

  function segnala(nome, dati) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', nome, dati || {});
    } catch (e) { /* mai far cadere la pagina per una statistica */ }
  }

  // Chi usa il pannello lo riceve subito, come prima.
  try {
    if (window.localStorage && localStorage.getItem(CHIAVE_PREF)) return;
  } catch (e) {
    // localStorage negato (navigazione privata, blocchi): nel dubbio non si
    // rinvia nulla. Meglio una pagina piu' pesante che un pannello mancante.
    return;
  }

  var urlVero = null;
  var caricato = false;

  var osservatore = new MutationObserver(function (mutazioni) {
    for (var i = 0; i < mutazioni.length; i++) {
      var aggiunti = mutazioni[i].addedNodes;
      for (var j = 0; j < aggiunti.length; j++) {
        var n = aggiunti[j];
        if (!n || n.nodeName !== 'SCRIPT') continue;
        var src = n.getAttribute && n.getAttribute('src');
        if (!src || src.indexOf(FILE) === -1) continue;
        urlVero = src;
        // Lo script e' `defer`: esegue a fine analisi del documento. Toglierlo
        // adesso ne impedisce l'esecuzione, che e' il costo vero.
        n.type = 'text/vcb-rinviato';
        if (n.parentNode) n.parentNode.removeChild(n);
      }
    }
  });

  try {
    osservatore.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {
    return; // niente MutationObserver: si lascia fare tutto come prima
  }

  // Se a fine caricamento non l'abbiamo mai visto, il nome del file e' cambiato
  // o l'app e' stata rimossa. In entrambi i casi vogliamo saperlo.
  window.addEventListener('load', function () {
    try { osservatore.disconnect(); } catch (e) {}
    if (!urlVero) segnala('vcb_a11y_non_intercettato', { file_atteso: FILE });
  });

  function carica(apri) {
    if (caricato) {
      if (apri) apriPannello();
      return;
    }
    caricato = true;
    if (!urlVero) return;              // non intercettato: fa da se'
    var s = document.createElement('script');
    s.src = urlVero;
    s.async = false;
    s.onload = function () { if (apri) apriPannello(); };
    s.onerror = function () { segnala('vcb_a11y_caricamento_fallito', {}); };
    document.head.appendChild(s);
    segnala('vcb_a11y_caricato_su_richiesta', {});
  }

  function apriPannello() {
    // L'API compare qualche istante dopo l'esecuzione dello script: si riprova
    // per un paio di secondi, poi si lascia perdere in silenzio (il grilletto
    // di Pandectes e' comunque agganciato al link e funzionera' al clic dopo).
    var tentativi = 0;
    var t = setInterval(function () {
      var api = window.PandectesAccessibility;
      if (api && typeof api.openDialog === 'function') {
        clearInterval(t);
        try { api.openDialog(); } catch (e) {}
      } else if (++tentativi > 40) {
        clearInterval(t);
      }
    }, 50);
  }

  // Un solo ascoltatore in cattura sul documento: funziona anche per i link
  // aggiunti dopo (footer renderizzato via Section Rendering, menu differiti).
  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (!t.closest(SELETTORE)) return;
      ev.preventDefault();
      carica(true);
    } catch (e) {}
  }, true);

  // Da tastiera: Invio e Spazio su un link non producono sempre un `click`
  // sintetico prima che il browser segua l'ancora. Chi naviga da tastiera e'
  // esattamente il pubblico di questo pannello: qui non si puo' sbagliare.
  document.addEventListener('keydown', function (ev) {
    try {
      if (ev.key !== 'Enter' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
      var t = ev.target;
      if (!t || !t.closest || !t.closest(SELETTORE)) return;
      ev.preventDefault();
      carica(true);
    } catch (e) {}
  }, true);
})();
